// @flow
import React from 'react'

// import ProgressStyles from './progress.style'
import styles from './progress.module.scss'

const RADIUS = 54
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

interface Props {
  value: number
  max?: number
  size?: string | number
  text?: string
  color?: string
}

const ProgressCircle = ({ value, max, size, text, color }: Props) => {
  const dashoffset = CIRCUMFERENCE * (1 - value / max)
  return (
    <svg className={styles.progressCircle} width={size} viewBox="0 0 120 120">
      <circle className="meter" cx="60" cy="60" r="54" strokeWidth="5" />
      <circle
        className={`${styles.circle} ${styles.value} ${styles.transition} ${styles[color]}`}
        cx="60"
        cy="60"
        r="54"
        strokeWidth="5"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={dashoffset}
      />
      <text x="60" y="70" textAnchor="middle">
        {text}
      </text>
    </svg>
  )
}

ProgressCircle.defaultProps = {
  max: 100,
  size: 120,
  text: '',
  color: '',
}

export default ProgressCircle
